import { ApiError } from "../api";
import type { useI18n } from "../../i18n";

export function localizedError(
  reason: unknown,
  t: ReturnType<typeof useI18n>["t"],
  has: ReturnType<typeof useI18n>["has"],
  fallbackKey = "errors.fallback"
): string {
  if (reason instanceof ApiError) {
    const key = `errors.${reason.code}`;
    return has(key) ? t(key, reason.params) : t(fallbackKey);
  }
  return t(fallbackKey);
}
